import { useBodyLockScroll } from "@kanpla/system";

export const Lock = () => {
  useBodyLockScroll();
  return null;
};
